import React, { useState } from 'react';
import {
	TextField,
	Button,
	List,
	ListItem,
	ListItemText,
	Dialog,
	DialogContent,
	DialogActions,
	Typography,
	ListItemSecondaryAction,
	IconButton,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { incrementVersion } from '../../actions/version';
import { handleSuccess } from '../../helpers/utils';

export const NewVersionFeaturesDialog = ({ open, handleClose }) => {
	const [inputText, setInputText] = useState('');
	const [features, setFeatures] = useState([]);

	const handleAddItem = () => {
		if (inputText.trim() !== '') {
			setFeatures([...features, inputText]);
			setInputText('');
		}
	};

	const reset = () => {
		setFeatures([]);
		handleClose();
	}

	const handleUpdateversion =  () => {
		incrementVersion(features).then(() => {
			handleSuccess(`Nueva versión: ${newVersion}`);
			reset()
		});
	};

	const handleTextFieldChange = (event) => {
		setInputText(event.target.value);
	};

	const handleDeleteItem = (index) => {
		const newItems = [...features];
		newItems.splice(index, 1);
		setFeatures(newItems);
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogContent>
				<Typography variant='h5' gutterBottom>
					Cambios en la nueva versión.
				</Typography>
				<br />
				<TextField
					label='Describe los cambios'
					variant='standard'
					autoFocus
					fullWidth
					value={inputText}
					onChange={handleTextFieldChange}
					onKeyPress={(event) => {
						if (event.key === 'Enter') {
							handleAddItem();
						}
					}}
				/>
				<List>
					{features.map((item, index) => (
						<ListItem key={index}>
							<ListItemText primary={`• ${item}`} />
							<ListItemSecondaryAction>
								<IconButton
									edge='end'
									aria-label='delete'
									onClick={() => handleDeleteItem(index)}
								>
									<DeleteIcon />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions>
				<Button onClick={reset}>Cancelar</Button>
				<Button onClick={handleUpdateversion} color='primary'>
					Actualizar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
